export enum NotificationStatusEnum {
  unread = 'unread',
  read = 'read',
  dismissed = 'dismissed',
  archived = 'archived',
}
